import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthServiceService } from '../../../pages/account/login/services/auth-service.service';

@Component({
  selector: 'app-header-one',
  templateUrl: './header-one.component.html',
  styleUrls: ['./header-one.component.scss']
})
export class HeaderOneComponent implements OnInit {
  
  //@Input() class: string = 'fondo-negro';
  // @Input() themeLogo: string = 'https://izzimoviles.s3.us-east-1.amazonaws.com/Imagenes/GIGMAX_WHITE.png'; //'assets/images/icon/logo_bt_white.png'; // Default Logo
  @Input() themeLogo: string = 'assets/images/icon/logo_gigmax.webp'; //'assets/images/icon/logo_bt_white.png'; // Default Logo
  @Input() topbar: boolean = true; // Default True
  @Input() sticky: boolean = false; // Default false
  
  public stick: boolean = false;
  public usuario;
  public btnIniciar: string = "Iniciar";
  constructor(private router:Router,private authService:AuthServiceService, private location: Location) { }

  ngOnInit(): void {
    this.usuario  = this.authService.getUser();
    if(this.usuario !== null) {
      this.btnIniciar = `Hola, ${this.usuario.nombre}`
    }
  }

  // @HostListener Decorator
  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  	if (number >= 150 && window.innerWidth > 400) { 
  	  this.stick = true;
  	} else {
  	  this.stick = false;
  	}
  }
  
  logout(){
    this.authService.logout();
    // this.router.navigateByUrl('/pages/login');
    this.location.replaceState('/home/watch');
    window.location.reload();
  }
}
